import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "How It Works", href: "#how-it-works", id: "nav-how-it-works" },
  { label: "What We Handle", href: "#services", id: "nav-what-we-handle" },
  { label: "Who It's For", href: "#who", id: "nav-who-its-for" },
  { label: "About", href: "#about", id: "nav-about" },
  { label: "Get Started", href: "#get-started", id: "nav-get-started" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-neutral-800"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-20 flex items-center justify-between">
        <a href="#home" data-testid="header-logo" aria-label="I Stay Trucking home">
          <img src="/logo.png" alt="I Stay Trucking" className="h-12 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="text-sm font-semibold uppercase tracking-wider text-neutral-300 transition-colors duration-200 hover:text-orange-500"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#get-started"
          data-testid="header-cta-button"
          className="hidden lg:inline-flex items-center bg-orange-500 px-6 py-3 font-display text-sm font-semibold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-orange-600"
        >
          Book A Call
        </a>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-neutral-800 bg-black/95 px-5 py-6 flex flex-col gap-5" data-testid="mobile-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.id}-mobile`}
              onClick={() => setOpen(false)}
              className="font-display text-lg font-semibold uppercase tracking-wider text-neutral-200 transition-colors duration-200 hover:text-orange-500"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#get-started"
            data-testid="mobile-nav-cta"
            onClick={() => setOpen(false)}
            className="mt-2 inline-flex justify-center bg-orange-500 px-6 py-4 font-display text-base font-semibold uppercase tracking-wider text-white"
          >
            Book A Call
          </a>
        </nav>
      )}
    </header>
  );
};
